import { __decorate } from "tslib";
// NPM
import _ from "lodash";
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EmployeeModule from "@/store/modules/employee.module";
import Loader from "../../../components/widgets/loader.vue";
import Simplebar from "simplebar-vue";
import EcGrid from "@/components/widgets/EcGrid.vue";
import SectionLoader from "../../../components/widgets/SectionLoader.vue";
import ExternalApiSyncComponent from "./components/ExternalApiSyncComponent.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
import { toaster } from "@/utilities/toaster";
/**
 * Employee Listing Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let EmployeesListing = /** @class */ (() => {
    let EmployeesListing = class EmployeesListing extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.pageIsLoading = true;
            this.isPageLoading = false;
            this.isPageDirty = false;
            this.isPageChanged = false;
            this.showIntegrationModal = false;
            this.searchKey = "";
            this.showEmployeeDeactivationUI = false;
            this.title = "Employees";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Employees",
                    active: true,
                },
            ];
            this.showModal = false;
            this.isLoading = false;
            // Grid
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.initialSortBy = {
                field: "employeeId",
                type: "asc",
            };
            this.columns = [
                {
                    field: "employeeId",
                    label: "Employee ID",
                    tdClass: "employee-id",
                    thClass: "employee-id-header",
                    filterOptions: {
                        enabled: true,
                        placeholder: "Emp ID",
                    },
                },
                {
                    field: "firstName",
                    label: "First Name",
                    thClass: "employee-name-header",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "First Name",
                    },
                },
                {
                    field: "lastName",
                    label: "Last Name",
                    thClass: "employee-name-header",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Last Name",
                    },
                },
                {
                    field: "emailId",
                    label: "Email",
                    sortable: false,
                    filterOptions: {
                        enabled: false,
                    },
                },
                {
                    field: "status",
                    label: "Status",
                    sortable: false,
                },
                {
                    field: "actions",
                    label: "Actions",
                    tdClass: "employee-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "employeeId",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
            this.employeeId = "";
            this.showEmployeeDeleteUI = false;
        }
        // METHODS
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                //gridOption: {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            EmployeeModule.AssignSearchParams(searchData);
            EmployeeModule.GetAllEmployees(searchData).then((response) => {
                this.isPageDirty = false;
                this.totalCount = response.totalCount;
                this.isGridLoading = false;
            });
        }
        integrationModal() {
            this.showIntegrationModal = false;
        }
        SyncFromExtenalApi() {
            this.showIntegrationModal = true;
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        assignColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            var gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (this.gridParams && this.gridParams.columnFilters.length > 0) {
                this.isPageDirty = true;
                this.gridParams.columnFilters.forEach((item) => {
                    gridColumns[item.name] = item.value;
                });
            }
        }
        get gridParams() {
            return EmployeeModule.searchParams;
        }
        deleteEmployee(employeeId) {
            this.employeeId = employeeId;
            this.showEmployeeDeleteUI = true;
        }
        deletingEmployee() {
            EmployeeModule.DeleteEmployee(this.employeeId).then((response) => {
                if (response) {
                    toaster.ShowSuccess("The Employee has been deleted.");
                    this.loadItems();
                    this.cancel();
                }
                else {
                    this.cancel();
                }
            });
        }
        cancel() {
            this.showEmployeeDeleteUI = false;
            this.showEmployeeDeactivationUI = false;
            this.employeeId = "";
        }
        get rows() {
            return EmployeeModule.Employees;
        }
        //Methods
        onRowClick(params) {
            console.log(params.row.id);
            this.$router.push({ name: "ViewEmployee", params: { employeeId: params.row.employeeId } });
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "EditEmployee" && from.name != "ViewEmployee") {
                EmployeeModule.ClearSearchParams();
            }
            next();
        }
        deactivatingEmployee() {
            EmployeeModule.DeactivateEmployee(this.employeeId).then((response) => {
                if (response) {
                    toaster.ShowSuccess("The Employee has been deactivated.");
                    this.loadItems();
                }
                else {
                    this.cancel();
                }
            });
        }
        deactivateEmployee(employeeId) {
            this.showEmployeeDeactivationUI = true;
            this.employeeId = employeeId;
        }
        initialize() {
            var value = EmployeeModule.searchParams;
            if (value != null) {
                this.isPageDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                value.columnFilters.forEach((item) => {
                    this.serverParams.columnFilters[item.name] = item.value;
                });
                this.initialSortBy = value.sort;
            }
        }
        //Computed
        get employees() {
            return EmployeeModule.Employees;
        }
        get filteredEmployees() {
            if (this.searchKey != "") {
                return EmployeeModule.Employees.filter((x) => x.firstName.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1 || x.lastName.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1);
            }
            return EmployeeModule.Employees;
        }
        get externalApiProvider() {
            console.log(EmployeeModule.ExternalApiProvider);
            return EmployeeModule.ExternalApiProvider;
        }
        get sortedFilteredEmployees() {
            return _.sortBy(this.filteredEmployees, (item) => item.employeeId);
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        // Excel Export
        GenerateEmployeeAsExcel() {
            this.isPageLoading = true;
            EmployeeModule.GetEmployeesExcelExport().then((response) => {
                if (response) {
                    const blob = new Blob([response], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.download = `EmployeeExport.xlsx`;
                    link.click();
                }
                this.isPageLoading = false;
            });
        }
        mounted() {
            this.assignColumnFilters();
        }
        //Lifecycle
        created() {
            this.initialize();
        }
    };
    EmployeesListing = __decorate([
        Component({
            name: "EmployeesListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                Simplebar,
                SectionLoader,
                ExternalApiSyncComponent,
                EcGrid,
                DeleteComponent,
            },
        })
    ], EmployeesListing);
    return EmployeesListing;
})();
export default EmployeesListing;
